// extracted by mini-css-extract-plugin
export default {"home__container":"home_home__container__dp3ky","app__modal":"home_app__modal__ajJak"};